<template>
  <div class="container-fluid" style="margin-top: 0">
    <div class="row-fluid">
      <!--最新活动-->
      <div class="span12 text-left" style="margin-top: 10px">
        <div class="cent" v-if="list == ''">暂无积分信息</div>
        <div class="aa" v-for="(item, index) in list" v-else :key="index">
          <div class="row">
            <div class="col-9" style="padding-left: 25px">
              <h5 class="title1">【{{ item.describe }}】{{ item.title }}</h5>
              <footer class="time">{{ item.time }}</footer>
            </div>
            <div class="jifen" v-if="item.describe == '完成服务'">
              +{{ item.integral }}
            </div>
            <div class="jifen" v-else>{{ item.integral }}</div>
          </div>
        </div>
        <div v-if="list != ''">
          <button
            v-if="moreShowBoolen"
            @click="moreShow1"
            class="btn_page btn1"
            style="
              display: block;
              margin: 25px auto 0;
              outline: none;
              color: #666;
              background-color: #eee;
              border-radius: 25px;
              height: 30px;
              width: 60%;
            "
          >
            更多选项
          </button>
          <div v-else style="text-align: center; margin-top: 15px">
            已无更多
          </div>
        </div>
        <div id="d_p"></div>
      </div>
    </div>
  </div>
</template>
<script>
import user_model from "../tool/user_model";
export default {
  data() {
    return {
      list: [],
      nowPage: 1,
      moreShowBoolen: false,
      nowPage_t: 1,
    };
  },
  components: {},
  props: {},
  created() {},
  mounted() {
    this.moreShow1();
    // const info = user_model.getUserinfo()
    // this.$api.getAPI("server/integral/?appid=202108&state=1", {
    //   openid: info.openid
    // }).then(res => {
    //   // console.log(res.data.data.data);
    //   var j = 0
    //   for (let i = 0; i < res.data.data.data.length; i++) {
    //     if (res.data.data.data[i].integral == 0) { } else {
    //       this.list.push(res.data.data.data[i])
    //       // console.log(res.data.data[i].time);
    //       var date = new Date(res.data.data.data[i].time * 1000);
    //       var Y = date.getFullYear() + '-';
    //       var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    //       var D = date.getDate() + ' ';
    //       var h = date.getHours() + ':';
    //       var m = date.getMinutes() + ':';
    //       var s = date.getSeconds();
    //       this.list[j].time = Y + M + D + h + m + s
    //       j++;
    //     }
    //   }
    // })
  },
  methods: {
    moreShow1() {
      // 点击查询更多
      //if(pageid)
      const info = user_model.getUserinfo();
      this.$api
        .getAPI("server/integral/?appid=202108&state=1&size=10", {
          page: this.nowPage,
          openid: info.openid,
        })
        .then((res) => {
          let ff = [];
          ff = res.data.data.data;
          this.aa(ff);
          for (let i = 0; i < ff.length; i++) {
            if (ff[i].integral == 0) {
            } else {
              this.list.push(ff[i]);
            }
          }
          var db = res.data.data;
          this.nowPage_t = db.count;
          this.moreShowBoolen = true;
          if (this.nowPage_t < this.nowPage * 10) {
            this.moreShowBoolen = false;
          }
          this.nowPage++;
        });
    },
    aa(list) {
      // console.log(list);
      for (let i = 0; i < list.length; i++) {
        if (list[i].time == 0) {
        } else {
          var date = new Date(list[i].time * 1000);
          var Y = date.getFullYear() + "-";
          var M =
            (date.getMonth() + 1 < 10
              ? "0" + (date.getMonth() + 1)
              : date.getMonth() + 1) + "-";
          var D = date.getDate() + " ";
          var h = date.getHours() + ":";
          var m = date.getMinutes() + ":";
          var s = date.getSeconds();
          list[i].time = Y + M + D + h + m + s;
        }
      }
    },
  },
};
</script>
<style>
.btn1 {
  border: none;
  outline: 0;
  background: none;
}
.cent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #777;
  font-size: 20px;
}

.aa {
  border-bottom: 1px solid #f2f2f2;
  height: 70px;
  position: relative;
}

.title1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  margin-top: 16px;
  margin-bottom: 5px;
}

.time {
  color: #d6d6d6;
  margin-bottom: 5px;
}

.jifen {
  position: absolute;
  top: 35px;
  transform: translateY(-50%);
  right: 10px;
  font-size: 20px;
  color: #ffd986;
}

.jumbotron {
  padding: 2rem 2rem;
  margin-bottom: 2rem;
}

.label_50 {
  border-radius: 50px/50px;
}

.page-header {
  margin: 25px 0 0px;
}

.h5_t_5 {
  margin-top: 15px;
}

.b_t_5 {
  padding-top: 6px;
}

.border_ {
  background: #002752;
}

.carousel-inner {
  border-bottom: 1px solid #000;
}

.carousel-indicators {
  bottom: -40px;
}

.carousel-indicators li {
  background-color: #000000;
}

.carousel-item-img {
  border-top-left-radius: 0.8em;
  border-top-right-radius: 0.8em;
  background-color: transparent;
  box-shadow: 0px 0px 8px 3px #fff;
}

.border {
  display: inline-block;
  width: 70px;
  height: 70px;
  margin: 6px;
}

.jumbotron_a {
  color: #fff;
  background: #01b2c2;
}

.jumbotron_b {
  color: #fff;
  background: #3480fa;
}

.jumbotron_c {
  background: #f3f4f8;
}

.carousel-indicators li {
  width: 8px;
  height: 8px;
  background-color: #00cdc6;
}

.carousel-indicators .active {
  background-color: #00a4b7;
  width: 30px;
  height: 8px;
}

.label-primary {
  color: #3480fa;
  background-color: #ffd986;
}

.label-primary-j {
  color: #fff;
  background-color: #00a4b7;
  border-radius: 15px 0px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/user_tidings_list.vue